import { Component } from '@angular/core';

import { Task } from '../../../entities/task.entity';
import { TaskDtoCellComponent } from '../task-dto-cell.component';

@Component({
    standalone: false,
    selector: 'digihaven-task-type-cell',
    templateUrl: './task-type-cell.component.html'
})
export class TaskTypeCellComponent extends TaskDtoCellComponent {
    protected readFromTask(task: Task): string | undefined {
        return task.task.TaskInfo?.Name;
    }
}
